import { render, staticRenderFns } from "./CommissionsDialog.vue?vue&type=template&id=19f90ea9&scoped=true"
import script from "./CommissionsDialog.vue?vue&type=script&lang=js"
export * from "./CommissionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f90ea9",
  null
  
)

export default component.exports